'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Constants
 * @type {string}
 */
var DEFAULT_AFFILIATION = exports.DEFAULT_AFFILIATION = 'www.racingpost.com';
var CATEGORY_UPGRADE = exports.CATEGORY_UPGRADE = 'upgrade';
var CATEGORY_SUBSCRIPTION = exports.CATEGORY_SUBSCRIPTION = 'subscription';
var MESSAGE_ERROR_NO_ANALYTICS = exports.MESSAGE_ERROR_NO_ANALYTICS = 'window.analytics is not defined.';
var MESSAGE_ERROR_NO_ANALYTICS_DEBUG = exports.MESSAGE_ERROR_NO_ANALYTICS_DEBUG = 'window.analytics.debug is not defined.';

var EVENT_KEY = exports.EVENT_KEY = 'event';
var LOCATION_KEY = exports.LOCATION_KEY = 'Location';
var BOOKMAKER_KEY = exports.BOOKMAKER_KEY = 'Bookmaker';
var EVENT_TYPE_KEY = exports.EVENT_TYPE_KEY = 'Event_Type';
var EVENT_NAME = exports.EVENT_NAME = 'Bookmaker_Event';

var API_NAME_TO_KEY = exports.API_NAME_TO_KEY = {
    bet365: 'bet365_logged_in_web',
    coral: 'coral_logged_in_web',
    williamhill: 'william_hill_logged_in_web',
    paddypower: 'paddy_power_logged_in_web',
    betfair: 'betfair_logged_in_web',
    ladbrokes: 'ladbrokes_logged_in_web',
    skybetflutter: 'skybet_logged_in_web'
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/~/rp-analytics/lib/constants.js
// module id = 79
// module chunks = 1